$(function() {
    "use strict";
    var e;
    new learningly.FormKeepSubmitter(".js-form");
    for (e in learningly.validators) {
        var t = learningly.validators[e];
        window.ParsleyValidator.addValidator(e, t.handler).addMessage("en", e, t.message)
    }
    $(document).on("opened", ".remodal", function() {
        window._gaq && _gaq.push(["_trackPageview", location.pathname + location.search + location.hash])
    })
}),
function(e) {
    "use strict";

    function t(e) {
        var t = e.data("form-audience");
        e[0].reset(), n(t + "-success")
    }

    function a() {
        n("error")
    }

    function n(e) {
        $.remodal && $.remodal.lookup[$("[data-remodal-id=" + e + "-message]").data("remodal")].open()
    }

    function r(e) {
        e.preventDefault();
        var n = $(this),
            r = n.attr("action"),
            i = n.serialize();
        $.ajax({
            url: r,
            type: "POST",
            headers: {
                Accept: "application/javascript"
            },
            dataType: "JSON",
            data: i
        }).done(t.bind(null, n)).fail(a)
    }

    function i(e) {
        var t = $(e);
        t.length && jQuery.fn.parsley && t.on("submit", r).parsley()
    }
    e.FormKeepSubmitter = i
}(window.learningly || (window.learningly = {}));